import { render, staticRenderFns } from "./HeaderSort.vue?vue&type=template&id=0346bbc8&scoped=true"
import script from "./HeaderSort.vue?vue&type=script&lang=js"
export * from "./HeaderSort.vue?vue&type=script&lang=js"
import style0 from "./HeaderSort.vue?vue&type=style&index=0&id=0346bbc8&prod&scoped=true&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_css-loader@6.11.0_webpack@5.111.1_postcss@8_85d782cab7005a7ea310986ee9f98c36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0346bbc8",
  null
  
)

export default component.exports